/* eslint-disable react/jsx-no-useless-fragment */
import { BoxComponent } from '../../../../../base/box/Box';
import { memo, useEffect, useState } from 'react';
import Item from '../Item';
import {
  getLastItemIndexOfCategory,
  getScaleSize,
  getTemplate6Items,
  isBetweenRange,
} from '../../../../../utils/utils';
import { MenuCategoriesProps, Template } from '@zeus/shared';
import { TypographyComponent } from '../../../../../base/typography/Typography';
//import { GridComponent } from '../../../../../base/grid/Grid';
import { TEMPLATE_1_MODIFIERS } from '../../../../../utils/consts';
import { useNormalizedPixels } from '../../../../../hooks/useResize';
import { Grid as GridComponent } from '../../../../../base19/grid/Grid';

interface CategoryProps {
  template: Omit<Template, 'content'>;
  category: MenuCategoriesProps | null;
  development?: boolean;
  timezone?: string;
  scale?: number;
  categoryIndex: number;
  fontFamily?: string;
}

const Category = ({
  template,
  development,
  category,
  timezone,
  categoryIndex,
  scale = 1,
  fontFamily: fontFamilyProp,
}: CategoryProps) => {
  const [active, setActive] = useState<boolean | null>(true);

  const { normalizePixels } = useNormalizedPixels();

  useEffect(() => {
    if (!development) {
      const intervalId = setInterval(() => {
        setActive(isBetweenRange(category?.schedules, timezone));
      }, 10000);

      return () => clearInterval(intervalId);
    }
  }, []);

  const sortedItems = getTemplate6Items(category, template?.itemsLimit, TEMPLATE_1_MODIFIERS, timezone, development);
  const hasAnyModifier = sortedItems.some((item) => item.hasValidModifiers);
  const isDevelopment = development ? true : isBetweenRange(category?.schedules, timezone);
  const lastItemIndex = getLastItemIndexOfCategory(sortedItems) ?? -1;
  const isCategoryEnabled = template?.category?.isEnabled ?? true;
  const isModifier = (hasAnyModifier || sortedItems.length === 0) && template?.itemPrice?.isEnabled;
  const fontFamily = fontFamilyProp || template?.fontFamilyName;

  return (
    active && (
      <>
        {isDevelopment && (
          <>
            {(isCategoryEnabled || isModifier) && (
              <BoxComponent
                sx={{
                  width: '45%',
                  height: 'auto',
                  maxWidth: '100%',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: isCategoryEnabled ? 'space-between' : 'flex-end',
                  alignItems: 'center',
                  ...(categoryIndex > 0 ? { marginTop: getScaleSize(normalizePixels(20, 'height'), scale) } : {}),
                }}
              >
                {isCategoryEnabled && (
                  <TypographyComponent
                    component={'h2'}
                    sx={{
                      color: template?.category?.color ? template?.category?.color : '#242528',
                      fontSize: getScaleSize(
                        normalizePixels(30 * Number(template?.category?.textScale ?? 1), 'height'),
                        scale
                      ),
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      width: isModifier ? '60%' : '100%',
                      whiteSpace: 'nowrap',
                      '-webkit-line-clamp': '1',
                      '-webkit-box-orient': 'vertical',
                      fontWeight: template.category?.fontWeight ?? '500',
                      fontStyle: template.category?.fontStyle,
                      letterSpacing: template.category?.letterSpacing,
                      lineHeight: template.category?.lineHeight,
                      textTransform: 'capitalize',
                      fontFamily: fontFamily,
                      paddingRight: getScaleSize(normalizePixels(10, 'width'), scale),
                    }}
                  >
                    {category?.name}
                  </TypographyComponent>
                )}

                {/* Modifier options */}
                {isModifier && (
                  <BoxComponent
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      width: '40%',
                    }}
                  >
                    <GridComponent container spacing={1} sx={{ width: '100%' }}>
                      {TEMPLATE_1_MODIFIERS.map((val) => (
                        <GridComponent key={val} item size={6}>
                          <TypographyComponent
                            sx={{
                              fontWeight: '400',
                              textAlign: 'center',
                              fontFamily: fontFamily,
                              lineHeight: 'normal',
                              color: template?.item?.itemName?.color ? template.item.itemName.color : '#510B03',
                              fontSize: getScaleSize(normalizePixels(12, 'height'), scale),
                              paddingY: getScaleSize(normalizePixels(5, 'height'), scale),
                              backgroundColor: '#FFC300',
                              borderRadius: '24px',
                            }}
                          >
                            {val}
                          </TypographyComponent>
                        </GridComponent>
                      ))}
                    </GridComponent>
                  </BoxComponent>
                )}
              </BoxComponent>
            )}

            {sortedItems.map((item, index) => (
              <Item
                key={`${item.id}-${active}`}
                item={item}
                template={template}
                development={development}
                index={index}
                lastItemIndex={lastItemIndex}
                timezone={timezone}
                scale={scale}
                hasAnyModifier={hasAnyModifier}
                itemsLength={sortedItems.length}
                fontFamily={fontFamily}
                categoryId={category?.id || 0}
              />
            ))}
          </>
        )}
      </>
    )
  );
};

export default memo(Category);
